module.exports = __webpack_public_path__ + "static/media/5-IMG_6692.9c86b0f8.JPG";